import { Constants } from "@utils/api-communication/ApiConstants";

const UID_REGEX = /^[0-9]+(\.[0-9]+)+$/;
const MAX_UID_LENGTH = 64;

export function getDicomUidRoot(): string {
  const root = Constants.instance?.DICOM_UID_ROOT?.trim();
  if (!root) {
    throw new Error(
      "DICOM UID root is not configured. Set dicom.uidRoot in the remote config before exporting DICOM.",
    );
  }
  if (!UID_REGEX.test(root) || root.length > MAX_UID_LENGTH) {
    throw new Error(`Configured DICOM UID root is invalid: "${root}"`);
  }
  return root;
}

export function deriveStudyInstanceUid(uidRoot: string): string {
  const epochMs = Date.now();
  const rand = 1_000_000 + Math.floor(Math.random() * 9_000_000);
  const uid = `${uidRoot}.${epochMs}.${rand}`;
  if (uid.length > MAX_UID_LENGTH) {
    throw new Error(`Derived StudyInstanceUID exceeds ${MAX_UID_LENGTH} chars; shorten uidRoot.`);
  }
  return uid;
}
